import axios from 'axios';
import { apiClient, apiErrorCode } from '@/lib/api-client';
import { ProfileRequiredError } from '@/modules/auth/domain/entities/auth.entity';
import {
  StudentRankingSchema,
  type StudentRanking,
} from '../../domain/entities/ranking.entity';
import type { RankingDatasource } from '../repositories/ranking.repository.impl';

/** A posição da própria pessoa, por nota bruta (`GET /exams-capture/ranking`). */
export const RANKING_ROUTE = '/exams-capture/ranking';

export class RankingApiDatasource implements RankingDatasource {
  /**
   * Sem posição não é falha:
   *
   * - `404` — a pessoa não enviou o gabarito;
   * - `422 RANKING_NOT_AVAILABLE` — enviou, mas o gabarito oficial ainda não
   *   saiu, então não há nota para posicionar.
   *
   * Os dois viram `null`; a aba já sabe, pela leitura do gabarito, qual dos
   * dois casos é. `403` é conta sem perfil aqui.
   */
  async getMine(exam: string, edition: number): Promise<StudentRanking | null> {
    try {
      const { data } = await apiClient.get<unknown>(RANKING_ROUTE, {
        params: { exam, edition },
      });
      return StudentRankingSchema.parse(data);
    } catch (error) {
      const status = axios.isAxiosError(error)
        ? error.response?.status
        : undefined;
      if (status === 404 || apiErrorCode(error) === 'RANKING_NOT_AVAILABLE') {
        return null;
      }
      if (status === 403) throw new ProfileRequiredError();
      throw error;
    }
  }
}
